module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/prasad-order-report/prasad-order-report.component.css
// module id = ./src/app/admin/components/prasad-order-report/prasad-order-report.component.css
// module chunks = main